var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.67188,
    y: 1.5614,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6719 42.5614H58.6719C59.2242 42.5614 59.6719 43.0091 59.6719 43.5614V52.5614C59.6719 53.666 58.7764 54.5614 57.6719 54.5614H23.6719C22.5673 54.5614 21.6719 53.666 21.6719 52.5614V43.5614C21.6719 43.0091 22.1196 42.5614 22.6719 42.5614H34.6719C38.6988 42.5614 42.044 42.5614 44.6719 42.5614Z",
    fill: "#C0DDE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6718 22.5614C41.2241 22.5614 41.6718 23.0091 41.6718 23.5614V27.5614C41.6718 28.1137 41.2241 28.5614 40.6718 28.5614C40.1196 28.5614 39.6718 28.1137 39.6718 27.5614V23.5614C39.6718 23.0091 40.1196 22.5614 40.6718 22.5614Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3789 25.2685C51.7694 25.659 51.7694 26.2922 51.3789 26.6827L48.7931 29.2685C48.4026 29.659 47.7694 29.659 47.3789 29.2685C46.9884 28.878 46.9884 28.2448 47.3789 27.8543L49.9647 25.2685C50.3552 24.878 50.9884 24.878 51.3789 25.2685Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9648 25.2685C28.5742 25.659 28.5742 26.2922 28.9648 26.6827L31.5506 29.2685C31.9411 29.659 32.5742 29.659 32.9648 29.2685C33.3553 28.878 33.3553 28.2448 32.9648 27.8543L30.379 25.2685C29.9885 24.878 29.3553 24.878 28.9648 25.2685Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5681 32.5614C27.8272 32.5614 27.1471 32.9709 26.8005 33.6256L21.8658 42.9467C21.8523 42.9722 21.84 42.9978 21.8287 43.0236C21.7294 43.1789 21.6719 43.3634 21.6719 43.5614V52.5614C21.6719 53.666 22.5673 54.5614 23.6719 54.5614H57.6719C58.7764 54.5614 59.6719 53.666 59.6719 52.5614V43.5614C59.6719 43.3634 59.6143 43.1788 59.515 43.0235C59.5038 42.9978 59.4914 42.9722 59.4779 42.9467L54.5432 33.6256C54.1966 32.9709 53.5165 32.5614 52.7757 32.5614H28.5681ZM57.6719 44.5614H23.6719L23.6719 52.5614H57.6719V44.5614ZM57.011 42.5614L52.7757 34.5614L28.5681 34.5614L24.3328 42.5614H57.011Z",
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.67188,
    y: 1.5614,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#E0E0E0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNoData);
export default __webpack_public_path__ + "static/media/table-no-data.3cbafacb7215d440d0f85bdd9ab017b2.svg";
export { ForwardRef as ReactComponent };